import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface STTResponse {
    id: number;
    transcription: string;
    filename: string;
}

@Injectable({
    providedIn: 'root'
})
export class STTResponseService {
    url: string = `${environment.sttService}/responses`;

    constructor(private _httpClient: HttpClient) {}

    list(): Observable<STTResponse[]> {
        return this._httpClient.get<STTResponse[]>(this.url, {});
    }

    get(id: number): Observable<STTResponse> {
        return this._httpClient.get<STTResponse>(`${this.url}/${id}`);
    }

    create(data: STTResponse): Observable<STTResponse> {
        return this._httpClient.post<STTResponse>(this.url, data);
    }

    update(data: STTResponse): Observable<STTResponse> {
        return this._httpClient.post<STTResponse>(
            `${this.url}/${data.id}`,
            data,
            {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json'
                })
            }
        );
    }

    delete(data: STTResponse): Observable<any> {
        return this._httpClient.delete(`${this.url}/${data.id}`);
    }
}
